import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Row, Col, Checkbox, message } from "antd";
import GeneralButton from "../../components/GeneralButton/GeneralButton";
import Toast from "../../components/Toast/Toast";
import ReservationInputForm from "../../forms/ReservationInputForm/ReservationInputForm";
import "../../styles/globals.css";
import "./ReservationEntryPage.css";
import { AppContext } from "../../contexts/AppContext";
import dayjs from "dayjs";

/**
 * 予約情報入力ページコンポーネント
 */
function ReservationEntryPage() {
  const {
    globalReservationInputForm,
    setGlobalReservationInputForm,
    setGlobalReservationInput,
    setGlobalSelectPatient,
    globalLoading,
  } = useContext(AppContext);
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [errors, setErrors] = useState({});
  const [agreementChecked, setAgreementChecked] = useState(false);

  /**
   * コンポーネントがマウントされた時にデータを取得
   */
  useEffect(() => {
    const loadDatas = async () => {
      window.scrollTo(0, 0);
      if (globalReservationInputForm) {
        form.setFieldsValue(globalReservationInputForm);

        // setBirthDayValue(
        //   dayjs(`${globalReservationInputForm?.birthDate}`).format("YYYY-MM-DD")
        // );
        setAgreementChecked(false);
      }
      setGlobalReservationInputForm(null);
    };

    if (!globalLoading) {
      loadDatas();
    }
  }, [globalLoading]);

  /**
   * 戻るボタン押下時の処理
   * @param {} なし
   * @return {} なし
   */
  const handleBackClick = () => {
    navigate("/account-verify");
  };

  /**
   * 予約確認に進むボタン押下時の処理
   * @param {} なし
   * @return {} なし
   */
  const handleConfirmClick = async () => {
    try {
      await form.validateFields();

      const formData = await form.getFieldsValue();
      setGlobalReservationInputForm(formData);

      const inputData = {
        medicalRecordNumber: formData?.cardNo,
        kanjiLast: formData?.lastName,
        kanjiFirst: formData?.firstName,
        kanaLast: formData?.lastKana,
        kanaFirst: formData?.firstKana,
        birthday: dayjs(`${formData?.birthDate}`).format("YYYY-MM-DD"),
        sex: formData?.gender,
        email: formData?.email,
        tel: formData?.phoneNumber,
        zipCode: formData?.postalCode,
        prefecture: formData?.prefecture,
        city: formData?.city,
        street: formData?.address,
        building: formData?.building,
      };

      setGlobalReservationInput(inputData);

      setGlobalSelectPatient(null);

      navigate("/reservation-confirm");
    } catch (error) {
      const fieldErrors = error.errorFields.reduce((acc, field) => {
        acc[field.name[0]] = true;
        return acc;
      }, {});
      setErrors(fieldErrors);
      showToast("入力に不備があります。ご確認ください", "error");
    }
  };

  /**
   * 同意チェックボックス変更時の処理
   * @param {object} e - イベントオブジェクト
   */
  const handleAgreementChange = (e) => {
    setAgreementChecked(e.target.checked);
  };

  const showToast = (content, type) => {
    const key = `open${Date.now()}`;
    const closeToast = () => {
      message.destroy(key);
    };

    message.open({
      content: <Toast content={content} type="check" onClose={closeToast} />,
      key,
      className: `ant-message-notice-content-${type}`,
    });
  };

  return (
    <div className="reservation-entry">
      <div className="main-area">
        <div className="title">受診者情報入力</div>
        <div className="detail">以下の必要項目に入力お願いします。</div>
        <div className="form">
          <Form
            form={form}
            name="registration"
            layout="vertical"
            initialValues={{ remember: true }}
          >
            <div>
              <ReservationInputForm
                form={form}
                errors={errors}
                setErrors={setErrors}
              />
              <Row gutter={16}>
                <Col span={24}>
                  <div className="explanation-area">
                    「
                    <a
                      href={process.env.REACT_APP_TERMS_OF_USE_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      利用規約
                    </a>
                    」<span>と</span>「
                    <a
                      href={process.env.REACT_APP_PRIVACY_POLICY_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      個人情報の取扱いについて
                    </a>
                    」 に同意の上、ご利用ください。
                  </div>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={24}>
                  <div className="agreement">
                    <Checkbox onChange={handleAgreementChange}>
                      利用規約・個人情報の取扱いについてに同意する
                    </Checkbox>
                  </div>
                </Col>
              </Row>
            </div>
          </Form>
        </div>
        <div className="general-buttons">
          <GeneralButton
            buttonLabel={"予約確認に進む"}
            type={
              Object.values(errors).some((error) => error) || !agreementChecked
                ? "disabled"
                : "primary-blue"
            }
            onClick={handleConfirmClick}
          />
          <GeneralButton
            buttonLabel={"戻る"}
            type={"secondary-white"}
            onClick={handleBackClick}
          />
        </div>
      </div>
    </div>
  );
}

export default ReservationEntryPage;
